module.exports = __webpack_public_path__ + "img/ResearchHUB Guiding Principles 11 06 2024-8.7fe47598.png";